//@flow
import { deviceTypes, manufacturers } from '~/core/constants/devices';

const sensor = ['checkPower', 'openSensorCase', 'checkPlacement', 'turnOffOn'];

const heating = [
    'pressBackButton',
    'checkPower',
    'pressTabThermostat',
    'checkHasLight',
    'callUs',
    'checkPlacement',
    'turnOffOn'
];

const nathermostat = ['naStep1', 'naStep2', 'naStep3'];

const plug = ['checkPlug', 'checkPower', 'turnPlugOff', 'checkPlacement', 'turnOffOn'];

const bulb = ['checkLight', 'checkPower', 'turnLightOffOn', 'checkPlacement', 'turnOffOn'];

const hueDevice = ['checkLight', 'checkBridge', 'contactPhilips'];
const hub = ['step1', 'step2', 'step3'];

export default {
    [deviceTypes.ACTIVE_PLUG]: plug,
    [deviceTypes.SIGNAL_BOOSTER]: plug,
    [deviceTypes.SMART_PLUG]: plug,
    [deviceTypes.BOILER_MODULE]: heating,
    [deviceTypes.NA_THERMOSTAT]: nathermostat,
    [deviceTypes.COLOR_TUNEABLE_LIGHT]: bulb,
    [deviceTypes.COLOR_LIGHT]: bulb,
    [deviceTypes.TUNEABLE_LIGHT]: bulb,
    [deviceTypes.WARM_WHITE_LIGHT]: bulb,
    [`${deviceTypes.COLOR_TUNEABLE_LIGHT}-${manufacturers.PHILIPS}`]: hueDevice,
    [`${deviceTypes.COLOR_LIGHT}-${manufacturers.PHILIPS}`]: hueDevice,
    [`${deviceTypes.TUNEABLE_LIGHT}-${manufacturers.PHILIPS}`]: hueDevice,
    [`${deviceTypes.WARM_WHITE_LIGHT}-${manufacturers.PHILIPS}`]: hueDevice,
    [deviceTypes.CONTACT_SENSOR]: sensor,
    [deviceTypes.MOTION_SENSOR]: sensor,
    [deviceTypes.HIVE_BUTTON]: sensor,
    [deviceTypes.HEATING]: heating,
    [deviceTypes.HOT_WATER]: heating,
    [deviceTypes.HUB]: hub,
    [deviceTypes.THERMOSTAT_UI]: heating,
    [deviceTypes.HUE_BRIDGE]: hueDevice,
    [deviceTypes.SENSE]: hub
};



// WEBPACK FOOTER //
// ./src/core/components/devices/offline/instructions.js